<div class="line-item w-100">
  <img
    height="140"
    width="140"
    *ngIf="lineItem.merchandise.image"
    [ngSrc]="lineItem.merchandise.image.transformedSrc"
  />
  <div class="d-flex flex-column w-100">
    <div class="line-item inner w-100">
      <div class="d-flex flex-column">
        <div class="title">
          {{ lineItem.merchandise.product.title.split("|")[0] }}
        </div>
        <div
          class="property"
          *ngFor="let option of lineItem.merchandise.selectedOptions"
        >
          {{ option.value !== "Default Title" ? option.value : "" }}
        </div>
      </div>
      <div class="d-flex flex-column ms-auto">
        <div class="price ms-3">
          <div>
            <s
              *ngIf="
                lineItem?.cost?.subtotalAmount?.amount &&
                lineItem.cost.subtotalAmount.amount >
                  lineItem.cost.totalAmount.amount
              "
              >{{ lineItem.cost.subtotalAmount.amount | currency }}</s
            >
          </div>

          <div>
            {{ lineItem.cost.totalAmount.amount | currency }}
          </div>
        </div>
      </div>
    </div>
    <div class="line-item justify-content-between mt-3">
      <div class="remove action" (click)="remove()">Remove</div>
      <div class="qty">
        <app-qty [lineItem]="lineItem"></app-qty>
      </div>
    </div>
  </div>
</div>

<div
  class="line-item w-100 d-flex flex-column pb-2 attr"
  *ngIf="_attributes.length > 0"
>
  <table class="d-table">
    <tr class="small" *ngFor="let entry of _attributes">
      <td class="td-text">{{ entry.prefix }}</td>
      <td class="td-text">{{ entry.key }}</td>
      <td class="pt-1">
        <div class="swatch" [style.backgroundColor]="entry.hex"></div>
      </td>
    </tr>
  </table>
</div>
<div class="line-item w-100 d-flex flex-column preorder" *ngIf="_preorder">
  Preorder: {{ _preorder.value }}
</div>
